"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const image_1 = require("../../utils/image");
function mapToButtonProps({ data, mappers, inHero }) {
    let button = null;
    if (!('blockType' in data)) {
        button = data;
    }
    else if (data.buttonReference && typeof data.buttonReference === 'object') {
        button = data.buttonReference;
    }
    let leftIcon = null;
    if (button?.leftIcon?.length) {
        leftIcon = mappers.mapBlock({
            block: button.leftIcon?.[0],
            mappers,
            inHero,
        });
    }
    let rightIcon = null;
    if (button?.rightIcon?.length) {
        rightIcon = mappers.mapBlock({
            block: button.rightIcon?.[0],
            mappers,
            inHero,
        });
    }
    let buttonFile;
    if (button?.document &&
        button.document?.[0]?.mediaReference &&
        typeof button.document[0].mediaReference !== 'number') {
        buttonFile =
            button.document[0].mediaReference &&
                (0, image_1.getMediaUrl)(button.document[0].mediaReference);
    }
    return {
        children: button?.text,
        to: buttonFile || button?.link,
        text: button?.text,
        color: button?.color?.toLowerCase(),
        outlined: button?.outlined,
        mobileText: button?.mobileText,
        cobra: button?.cobra,
        visibility: button?.visibility,
        leftIcon,
        rightIcon,
        variant: inHero ? 'hero' : null,
    };
}
exports.default = mapToButtonProps;
